<template>
    <el-dialog title="修改密码" :visible="isChangePassword" :width="'360px'" @close="passClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="旧密码" prop="old_password">
                <el-input type="password" v-model="form.old_password" autocomplete="off" placeholder="请输入旧密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="password">
                <el-input type="password" v-model="form.password" autocomplete="off" placeholder="请输入新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="password_confirmation">
                <el-input type="password" v-model="form.password_confirmation"
                    autocomplete="off" placeholder="请确认新密码"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <span @click="passClose">返回</span>
            <span @click="save">保存</span>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.form.password_confirmation !== '') {
                    this.$refs.form.validateField('password_confirmation');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            form: {
                password: '',
                password_confirmation: '',
                old_password: '',
            },
            rules: {
                old_password: [
                    { required: true, message: '请输入旧密码', trigger: 'blur' },
                ],
                password_confirmation: [{ required: true,validator: validatePass2, trigger: 'blur'  }],
                password: [{ required: true,validator: validatePass,trigger: 'blur' }],
            }
        }
    },
    props: {
        isChangePassword: {
            type: Boolean
        }
    },
    methods: {
        passClose() {
            this.$emit('closePass')
        },
        save() {           
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if(this.form.password.length < 6 ) {
                        this.$message.error('密码至少输入6个字符')                    
                    } else if(this.form.password.length > 32) {
                        this.$message.error('密码不能大于32个字符')   
                    }else {
                        this.$emit('savePass', this.form)
                    }
                    
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }

}
</script>

<style lang="scss" scoped>
.el-dialog__footer {
    .dialog-footer {
        display: flex;
        justify-content: center;
        text-align: center;

        span {
            margin: 0 20px;
            font-size: 14px;
            cursor: pointer;

            &:nth-child(2) {
                color: #2881cd;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/component/password/ChangePassword.vue